document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".dropdown-trigger").forEach(trigger => {
        trigger.addEventListener("click", function () {
            const content = this.nextElementSibling;
            if (content) {
                if (content.classList.contains("dropdown-content--open")) {
                    content.classList.remove("dropdown-content--open");
                    content.classList.add("dropdown-content");
                } else {
                    content.classList.remove("dropdown-content");
                    content.classList.add("dropdown-content--open");
                }
            }
        });
    });
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

(function ($) {
  var $ = (jQuery = $);
  var cc = {
    sections: [],
  };

  theme.Shopify = {
    formatMoney: function formatMoney(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t;
      }

      function a(t, r, a, o) {
        if (
          ((r = e(r, 2)),
            (a = e(a, ',')),
            (o = e(o, '.')),
            isNaN(t) || t == null)
        )
          return 0;
        t = (t / 100).toFixed(r);
        var n = t.split('.');
        return (
          n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + a) +
          (n[1] ? o + n[1] : '')
        );
      }

      typeof t === 'string' && (t = t.replace('.', ''));
      var o = '';
      var n = /\{\{\s*(\w+)\s*\}\}/;
      var i = r || this.money_format;

      switch (i.match(n)[1]) {
        case 'amount':
          o = a(t, 2);
          break;

        case 'amount_no_decimals':
          o = a(t, 0);
          break;

        case 'amount_with_comma_separator':
          o = a(t, 2, '.', ',');
          break;

        case 'amount_with_space_separator':
          o = a(t, 2, ' ', ',');
          break;

        case 'amount_with_period_and_space_separator':
          o = a(t, 2, ' ', '.');
          break;

        case 'amount_no_decimals_with_comma_separator':
          o = a(t, 0, '.', ',');
          break;

        case 'amount_no_decimals_with_space_separator':
          o = a(t, 0, ' ', '');
          break;

        case 'amount_with_apostrophe_separator':
          o = a(t, 2, "'", '.');
          break;

        case 'amount_with_decimal_separator':
          o = a(t, 2, '.', '.');
      }

      return i.replace(n, o);
    },
    formatImage: function formatImage(originalImageUrl, format) {
      return originalImageUrl.replace(
        /^(.*)\.([^\.]*)$/g,
        '$1_' + format + '.$2'
      );
    },
    Image: {
      imageSize: function imageSize(t) {
        var e = t.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );
        return e !== null ? e[1] : null;
      },
      getSizedImageUrl: function getSizedImageUrl(t, e) {
        if (e == null) return t;
        if (e == 'master') return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (o != null) {
          var i = t.split(o[0]);
          var r = o[0];
          return this.removeProtocol(i[0] + '_' + e + r);
        }

        return null;
      },
      removeProtocol: function removeProtocol(t) {
        return t.replace(/http(s)?:/, '');
      },
    },
  };

  theme.Disclosure = (function () {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]',
    };
    var classes = {
      listVisible: 'disclosure-list--visible',
    };

    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};

      this._cacheSelectors();

      this._connectOptions();

      this._connectToggle();

      this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function _cacheSelectors() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions),
        };
      },
      _connectToggle: function _connectToggle() {
        this.cache.$disclosureToggle.on(
          'click',
          function (evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
      _connectOptions: function _connectOptions() {
        this.cache.$disclosureOptions.on(
          'click',
          function (evt) {
            evt.preventDefault();

            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },
      _onFocusOut: function _onFocusOut() {
        this.cache.$disclosureToggle.on(
          'focusout',
          function (evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;

            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.cache.$disclosureList.on(
          'focusout',
          function (evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.$container.on(
          'keyup',
          function (evt) {
            if (evt.which !== 27) return; // escape

            this._hideList();

            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );

        this.bodyOnClick = function (evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this);

        $('body').on('click', this.bodyOnClick);
      },
      _submitForm: function _submitForm(value) {
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },
      _hideList: function _hideList() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },
      unload: function unload() {
        $('body').off('click', this.bodyOnClick);
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      },
    });
    return Disclosure;
  })();

  (function () {
    function throttle(callback, threshold) {
      var debounceTimeoutId = -1;
      var tick = false;
      return function () {
        clearTimeout(debounceTimeoutId);
        debounceTimeoutId = setTimeout(callback, threshold);

        if (!tick) {
          callback.call();
          tick = true;
          setTimeout(function () {
            tick = false;
          }, threshold);
        }
      };
    }

    var scrollEvent = document.createEvent('Event');
    scrollEvent.initEvent('throttled-scroll', true, true);
    window.addEventListener(
      'scroll',
      throttle(function () {
        window.dispatchEvent(scrollEvent);
      }, 200)
    );
  })(); // requires: throttled-scroll, debouncedresize

  theme.Sections = new (function () {
    var _ = this;

    _._instances = [];
    _._deferredSectionTargets = [];
    _._sections = [];
    _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport

    _._deferredWatcherRunning = false;

    _.init = function () {
      $(document)
        .on('shopify:section:load', function (e) {
          // load a new section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

          if (target) {
            _.sectionLoad(target);
          }
        })
        .on('shopify:section:unload', function (e) {
          // unload existing section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

          if (target) {
            _.sectionUnload(target);
          }
        });
      $(window).on(
        'throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader',
        _._processDeferredSections
      );
      _._deferredWatcherRunning = true;
    }; // register a type of section

    _.register = function (type, section, options) {
      _._sections.push({
        type: type,
        section: section,
        afterSectionLoadCallback: options ? options.afterLoad : null,
        afterSectionUnloadCallback: options ? options.afterUnload : null,
      }); // load now

      $('[data-section-type="' + type + '"]').each(function () {
        if (
          Shopify.designMode ||
          (options && options.deferredLoad === false) ||
          !_._deferredWatcherRunning
        ) {
          _.sectionLoad(this);
        } else {
          _.sectionDeferredLoad(this, options);
        }
      });
    }; // prepare a section to load later

    _.sectionDeferredLoad = function (target, options) {
      _._deferredSectionTargets.push({
        target: target,
        deferredLoadViewportExcess:
          options && options.deferredLoadViewportExcess
            ? options.deferredLoadViewportExcess
            : _._deferredLoadViewportExcess,
      });

      _._processDeferredSections(true);
    }; // load deferred sections if in/near viewport

    _._processDeferredSections = function (firstRunCheck) {
      if (_._deferredSectionTargets.length) {
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        var loopStart =
          firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;

        for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
          var target = _._deferredSectionTargets[i].target;
          var viewportExcess =
            _._deferredSectionTargets[i].deferredLoadViewportExcess;
          var sectionTop = $(target).offset().top - viewportExcess;
          var doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;

          if (!doLoad) {
            var sectionBottom =
              sectionTop + $(target).outerHeight() + viewportExcess * 2;
            doLoad =
              sectionBottom > viewportTop && sectionBottom < viewportBottom;
          }

          if (
            doLoad ||
            (sectionTop < viewportTop && sectionBottom > viewportBottom)
          ) {
            // in viewport, load
            _.sectionLoad(target); // remove from deferred queue and resume checks

            _._deferredSectionTargets.splice(i, 1);

            i--;
          }
        }
      } // remove event if no more deferred targets left, if not on first run

      if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
        _._deferredWatcherRunning = false;
        $(window).off('.themeSectionDeferredLoader');
      }
    }; // load in a section

    _.sectionLoad = function (target) {
      var target = target;
      var sectionObj = _._sectionForTarget(target);
      var section = false;

      if (sectionObj.section) {
        section = sectionObj.section;
      } else {
        section = sectionObj;
      }

      if (section !== false) {
        var instance = {
          target: target,
          section: section,
          $shopifySectionContainer: $(target).closest('.shopify-section'),
          thisContext: {
            functions: section.functions,
          },
        };

        _._instances.push(instance); // Initialise any components

        if ($(target).data('components')) {
          // Init each component
          var components = $(target).data('components').split(',');
          components.forEach(function (component) {
            $(document).trigger('cc:component:load', [component, target]);
          });
        }

        _._callWith(section, 'onSectionLoad', target, instance.thisContext);

        _._callWith(
          section,
          'afterSectionLoadCallback',
          target,
          instance.thisContext
        ); // attach additional UI events if defined

        if (section.onSectionSelect) {
          instance.$shopifySectionContainer.on(
            'shopify:section:select',
            function (e) {
              _._callWith(
                section,
                'onSectionSelect',
                e.target,
                instance.thisContext
              );
            }
          );
        }

        if (section.onSectionDeselect) {
          instance.$shopifySectionContainer.on(
            'shopify:section:deselect',
            function (e) {
              _._callWith(
                section,
                'onSectionDeselect',
                e.target,
                instance.thisContext
              );
            }
          );
        }

        if (section.onBlockSelect) {
          $(target).on('shopify:block:select', function (e) {
            _._callWith(
              section,
              'onBlockSelect',
              e.target,
              instance.thisContext
            );
          });
        }

        if (section.onBlockDeselect) {
          $(target).on('shopify:block:deselect', function (e) {
            _._callWith(
              section,
              'onBlockDeselect',
              e.target,
              instance.thisContext
            );
          });
        }
      }
    }; // unload a section

    _.sectionUnload = function (target) {
      var sectionObj = _._sectionForTarget(target);

      var instanceIndex = -1;

      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }

      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex]; // remove events and call unload, if loaded

        $(target).off('shopify:block:select shopify:block:deselect');
        instance.$shopifySectionContainer.off(
          'shopify:section:select shopify:section:deselect'
        );

        _._callWith(
          instance.section,
          'onSectionUnload',
          target,
          instance.thisContext
        );

        _._callWith(
          sectionObj,
          'afterSectionUnloadCallback',
          target,
          instance.thisContext
        );

        _._instances.splice(instanceIndex); // Destroy any components

        if ($(target).data('components')) {
          // Init each component
          var components = $(target).data('components').split(',');
          components.forEach(function (component) {
            $(document).trigger('cc:component:unload', [component, target]);
          });
        }
      } else {
        // check if it was a deferred section
        for (var i = 0; i < _._deferredSectionTargets.length; i++) {
          if (_._deferredSectionTargets[i].target == target) {
            _._deferredSectionTargets[i].splice(i, 1);

            break;
          }
        }
      }
    }; // helpers

    _._callWith = function (object, method, param, thisContext) {
      if (typeof object[method] === 'function') {
        if (thisContext) {
          object[method].bind(thisContext)(param);
        } else {
          object[method](param);
        }
      }
    };

    _._themeSectionTargetFromShopifySectionTarget = function (target) {
      var $target = $('[data-section-type]:first', target);

      if ($target.length > 0) {
        return $target[0];
      } else {
        return false;
      }
    };

    _._sectionForTarget = function (target) {
      var type = $(target).attr('data-section-type');

      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return _._sections[i];
        }
      }

      return false;
    };

    _._sectionAlreadyRegistered = function (type) {
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return true;
        }
      }

      return false;
    };
  })(); // Loading third party scripts

  theme.scriptsLoaded = {};

  theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
    if (typeof theme.scriptsLoaded[src] === 'undefined') {
      theme.scriptsLoaded[src] = [];
      var tag = document.createElement('script');
      tag.src = src;

      if (sync || beforeRun) {
        tag.async = false;
      }

      if (beforeRun) {
        beforeRun();
      }

      if (typeof callback === 'function') {
        theme.scriptsLoaded[src].push(callback);

        if (tag.readyState) {
          // IE, incl. IE9
          tag.onreadystatechange = function () {
            if (tag.readyState == 'loaded' || tag.readyState == 'complete') {
              tag.onreadystatechange = null;

              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }

              theme.scriptsLoaded[this] = true;
            }
          }.bind(src);
        } else {
          tag.onload = function () {
            // Other browsers
            for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }

            theme.scriptsLoaded[this] = true;
          }.bind(src);
        }
      }

      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else if (
      _typeof(theme.scriptsLoaded[src]) === 'object' &&
      typeof callback === 'function'
    ) {
      theme.scriptsLoaded[src].push(callback);
    } else {
      if (typeof callback === 'function') {
        callback();
      }

      return false;
    }
  };

  theme.loadStyleOnce = function (src) {
    var srcWithoutProtocol = src.replace(/^https?:/, '');

    if (
      !document.querySelector(
        'link[href="' + encodeURI(srcWithoutProtocol) + '"]'
      )
    ) {
      var tag = document.createElement('link');
      tag.href = srcWithoutProtocol;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      var firstTag = document.getElementsByTagName('link')[0];
      firstTag.parentNode.insertBefore(tag, firstTag);
    }
  }; /// Show a short-lived text popup above an element

  theme.showQuickPopup = function (message, $origin) {
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup
      .html(message)
      .css({
        left: offs.left,
        top: offs.top,
      })
      .hide();
    $('body').append($popup);
    $popup.css({
      marginTop: -$popup.outerHeight() - 10,
      marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
    });
    $popup
      .fadeIn(200)
      .delay(3500)
      .fadeOut(400, function () {
        $(this).remove();
      });
  };

  theme.NestedSectionsSection = new (function () {
    this.onSectionLoad = function (container) {
      // load child sections
      $('[data-nested-section-type]', container).each(function () {
        var type = $(this).attr('data-nested-section-type');
        var section = null;

        for (var i = 0; i < theme.Sections._sections.length; i++) {
          if (theme.Sections._sections[i].type == type) {
            section = theme.Sections._sections[i].section;
          }
        }

        if (section) {
          var instance = {
            target: this,
            section: section,
            $shopifySectionContainer: $(this).closest('.shopify-section'),
            thisContext: {},
          };

          theme.Sections._instances.push(instance);

          $(this).data('themeSectionInstance', instance);
          section.onSectionLoad.bind(instance.thisContext)(this);
        }
      });
    };

    this.onSectionUnload = function (container) {
      // unload child sections
      $('[data-nested-section-type]', container).each(function () {
        theme.Sections.sectionUnload.bind(
          $(this).data('themeSectionInstance').thisContext
        )(this);
      });
    };

    this.onBlockSelect = function (target) {
      // scroll to block
      $(window).scrollTop($(target).offset().top - 100);
    };
  })(); // Register the section

  cc.sections.push({
    name: 'nested-sections',
    section: theme.NestedSectionsSection,
  });
  theme.Navigation = {
    init: function init(options) {
      if (options.nav.length == 0) {
        return;
      }

      var $nav = options.nav;
      var navHoverDelay = 250;
      var $navLastOpenDropdown = $();
      var navOpenTimeoutId = -1; // hover events
      var navigationContainer = document.querySelector('#main-nav .navigation');

      $nav.on(
        'mouseenter mouseleave',
        '.navigation__tier-1 > .navigation__item--with-children',
        function (evt) {
          var $dropdownContainer = $(this); // delay on hover-out

          if (evt.type == 'mouseenter') {
            clearTimeout(navOpenTimeoutId);
            clearTimeout($dropdownContainer.data('navCloseTimeoutId'));
            var $openSiblings = $dropdownContainer.siblings(
              '.navigation__item--show-children'
            ); // close all menus but last opened
            $openSiblings
              .not($navLastOpenDropdown)
              .removeClass('navigation__item--show-children');
            $navLastOpenDropdown = $dropdownContainer; // show after a delay, based on first-open or not

            var newNavOpenTimeoutId = setTimeout(function () {
              $dropdownContainer
                .addClass('navigation__item--show-children')
                .siblings('.navigation__item--show-children')
                .removeClass('navigation__item--show-children');
              //Add class to main nav container for overlay
              if (navigationContainer) {
                navigationContainer.classList.add('navigation__open');
              }
            }, navHoverDelay);
            navOpenTimeoutId = newNavOpenTimeoutId;
            $dropdownContainer.data('navOpenTimeoutId', newNavOpenTimeoutId);
          } else {
            // cancel opening, close after delay, and clear transforms
            clearTimeout($dropdownContainer.data('navOpenTimeoutId'));
            $dropdownContainer.data(
              'navCloseTimeoutId',
              setTimeout(function () {
                $dropdownContainer.removeClass(
                  'navigation__item--show-children'
                );
                //Add class to main nav container for overlay
                if (
                  navigationContainer &&
                  !document.querySelector('.navigation__item--show-children')
                ) {
                  navigationContainer.classList.remove('navigation__open');
                }
              }, navHoverDelay)
            );
          } // a11y

          $dropdownContainer
            .children('[aria-expanded]')
            .attr('aria-expanded', evt.type == 'mouseenter');
        }
      ); // touch events on desktop

      var touchHandler = function touchHandler(evt) {
        if ($(window).width() > 767) {
          if (evt.type == 'touchstart') {
            $(this).data('touchstartedAt', evt.timeStamp);
          } else if (evt.type == 'touchend') {
            // down & up in under a second - presume tap
            if (evt.timeStamp - $(this).data('touchstartedAt') < 1000) {
              $(this).data('touchOpenTriggeredAt', evt.timeStamp);

              if (
                $(this).parent().hasClass('navigation__item--show-children')
              ) {
                // trigger close
                $(this).parent().trigger('mouseleave');
              } else {
                // trigger close on any open items
                $('.navigation:first .navigation__item--show-children').trigger(
                  'mouseleave'
                ); // trigger open

                $(this).parent().trigger('mouseenter');
              } // prevent fake click

              return false;
            }
          } else if (evt.type == 'click') {
            // if touch open was triggered very recently, prevent click event
            if (
              $(this).data('touchOpenTriggeredAt') &&
              evt.timeStamp - $(this).data('touchOpenTriggeredAt') < 1000
            ) {
              return false;
            }
          }
        }
      };

      $nav.on(
        'touchstart touchend click',
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__link',
        touchHandler
      ); // hit return on dropdown toggle

      var keydownHandler = function keydownHandler(evt) {
        if (evt.which == 13) {
          var $parent = $(this).parent();
          $parent.trigger(
            $parent.hasClass('navigation__item--show-children')
              ? 'mouseleave'
              : 'mouseenter'
          );
          return false;
        }
      };

      $nav.on(
        'keydown',
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle',
        keydownHandler
      ); // proxy for desktop nav interaction events

      if (options.proxyTier1Nav) {
        $(options.proxyTier1Nav)
          .on(
            'mouseenter mouseleave',
            '.navigation__tier-1 > .navigation__item--with-children',
            function (evt) {
              $(
                $('.navigation__tier-1 > .navigation__item', $nav)[
                $(this).index()
                ]
              ).trigger(evt.type);
            }
          )
          .on(
            'touchstart touchend click',
            '.navigation__tier-1 > .navigation__item--with-children > .navigation__link',
            function (evt) {
              var response = touchHandler.bind(
                $(
                  $('.navigation__tier-1 > .navigation__item', $nav)[
                  $(this).parent().index()
                  ]
                ).children('.navigation__link')[0]
              )(evt);

              if (response === false) {
                return false;
              }
            }
          )
          .on(
            'keydown',
            '.navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle',
            function (evt) {
              if (evt.which == 13) {
                keydownHandler.bind(
                  $(
                    $('.navigation__tier-1 > .navigation__item', $nav)[
                    $(this).parent().index()
                    ]
                  ).children('.navigation__children-toggle')[0]
                )(evt);
                return false;
              }
            }
          );
      } // mobile expansion

      $nav.on('click', '.navigation__children-toggle', function () {
        if (
          $(this)
            .parent()
            .toggleClass('navigation__item--mobile-open')
            .hasClass('navigation__item--mobile-open')
        ) {
          $(this)
            .siblings('.navigation__child-tier')
            .stop()
            .slideDown(300, function () {
              $(this)
                .parent()
                .addClass('navigation__item--mobile-open-finished');
              $(this).removeAttr('style');
            });
        } else {
          $(this)
            .siblings('.navigation__child-tier')
            .stop()
            .slideUp(300, function () {
              $(this)
                .parent()
                .removeClass('navigation__item--mobile-open-finished');
              $(this).removeAttr('style');
            });
        }

        return false;
      });
      

      const navClose = document.querySelectorAll('.navigation__close');
      if (navClose) {
        navClose.forEach(function (closeNav) {
          closeNav.addEventListener('click', function () {
            document
              .querySelector('.navigation__item--show-children')
              .classList.remove('navigation__item--show-children');
            document
              .querySelector('.navigation__open')
              .classList.remove('navigation__open');
          });
        });
      }

      document.querySelectorAll('.section-header .navigation .navigation__link').forEach(function(svgElement) {
        svgElement.addEventListener('click', function() {
          console.log(svgElement);
          let svg = svgElement.querySelector('.navigation__close svg');
          const currentRotation = svg.style.transform.replace(/[^\d.]/g, '') || 0;
          const newRotation = parseInt(currentRotation) + 45;
          svg.style.transform = `rotate(${newRotation}deg)`;
        });
      });
      

      const body = document.body;
      const scrollUp = 'scroll-up';
      const scrollDown = 'scroll-down';
      let lastScroll = 0;

      var returnedFunction = debounce(function () {
        if (document.querySelector('.reveal-mobile-nav') === null) {
          const currentScroll = window.pageYOffset;

          if (currentScroll === 0) {
            body.classList.remove(scrollUp);
            body.classList.remove(scrollDown);
            return;
          }

          if (
            currentScroll > lastScroll &&
            !body.classList.contains(scrollDown)
          ) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
          } else if (
            currentScroll < lastScroll &&
            body.classList.contains(scrollDown)
          ) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
          }

          lastScroll = currentScroll;
        }
      }, 100);

      window.addEventListener('scroll', returnedFunction);
    },
    destroy: function destroy($nav, $proxyTier1Nav) {
      $nav
        .add($proxyTier1Nav)
        .off('click mouseenter mouseleave touchstart touchend keydown');
    },
  };
  theme.icons = {
    left:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_left +
      '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
    right:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_right +
      '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
      theme.strings.icon_labels_close +
      '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    chevronLeft:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>' +
      theme.strings.icon_labels_left +
      '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
    chevronRight:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>' +
      theme.strings.icon_labels_right +
      '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
    chevronDown:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_down +
      '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
    tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
    label:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
  }; // Get Shopify feature support

  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector('#shopify-features').textContent
    );
  } catch (e) {
    theme.Shopify.features = {};
  }

  theme.FeaturedProductSection = new (function () {
    this.onSectionLoad = function (target) {
      $('[name="id"]', target).trigger('optionate');
      theme.classUpTextLinks(target);
      theme.initProductGallery(target);
    };

    this.onSectionUnload = function (target) {
      theme.destroyProductGallery(target);
      theme.OptionManager.unloadProductOptions($('[name="id"]', target));
      $('.slideshow', target).slick('unslick');
    };
  })();

  theme.CollectionTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.initToggleTargets();
      theme.classUpTextLinks(target); /// View modes for collection page

      $(target).on('click', '#view-as-tiles', function () {
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('#view-as-stream').removeClass('active');
          theme.saveGridStreamChoice('grid');
          var $listing = $('.collection-listing-stream')
            .addClass('collection-listing')
            .removeClass('collection-listing-stream');
          $(window).trigger('debouncedresize');
        }

        return false;
      });
      $(target).on('click', '#view-as-stream', function () {
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('#view-as-tiles').removeClass('active');
          theme.saveGridStreamChoice('stream');
          var $listing = $('.collection-listing')
            .removeClass('collection-listing')
            .addClass('collection-listing-stream'); // reset styling on blocks

          $(window).trigger('debouncedresize');
          $listing.find('.block-inner, .primary-image').removeAttr('style');
        }

        return false;
      }); /// Stream/grid view - saved setting

      if (
        $('#view-as-stream, #view-as-tiles', target).length > 0 &&
        theme.getGridStreamChoice() != null
      ) {
        if (theme.getGridStreamChoice() == 'stream') {
          $('#view-as-stream').trigger('click');
        } else {
          $('#view-as-tiles').trigger('click');
        }
      } /// Collection sorting

      var $sortBy = $('#sort-by', target);

      if ($sortBy.length > 0) {
        var queryParams = {};

        if (location.search.length) {
          for (
            var aKeyValue,
            i = 0,
            aCouples = location.search.substr(1).split('&');
            i < aCouples.length;
            i++
          ) {
            aKeyValue = aCouples[i].split('=');

            if (aKeyValue.length > 1) {
              queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1]);
            }
          }
        }

        $sortBy.on('change', function () {
          queryParams.sort_by = $(this).val();
          location.search = $.param(queryParams);
        });
      } /// If a tag is active in a group, other tags within that group must be links to that tag only, within that group.

      $('.multi-tag-row .tags', target).each(function () {
        var $active = $(this).find('li.active');
        $(this)
          .find('li:not(.active) a')
          .each(function () {
            var href = $(this).attr('href');
            $active.each(function () {
              var tag = $(this).data('tag');
              href = href.replace('+' + tag, '').replace(tag + '+', ''); // Collection

              href = href.replace('%2B' + tag, '').replace(tag + '%2B', ''); // Vendor
            });
            $(this).attr('href', href);
          });
      }); /// Style dropdowns

      theme.select2.init($('.filters .styled-select select', target));
      theme.ProductBlockManager.loadImages(target);
    };

    this.onSectionUnload = function (target) {
      theme.select2.destroyAllIn(target);
      $('#sort-by', target).off('change');
      $(target).off('click');
      theme.destroyProductGallery(target); // Clear grid/stream preference

      theme.saveGridStreamChoice(null);
    };
  })();
  theme.BlogTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.initToggleTargets();
      theme.classUpTextLinks(target);
    };
  })();

  theme.ImageWithTextOverlaySection = new (function () {
    var _ = this;

    _.checkForHeaderHeightSubtraction = function () {
      $(
        '.section-image-with-text-overlay .height--full-minus-header-height'
      ).each(function () {
        $(this).height($(window).height() - $('.section-header').height());
      });
    };

    this.onSectionLoad = function (container) {
      $('.height--full', container).each(function () {
        if ($(this).closest('.section-image-with-text-overlay').index() == 0) {
          $(this).addClass('height--full-minus-header-height');

          _.checkForHeaderHeightSubtraction();

          $(window)
            .off('debouncedresize.imageWithTextOverlaySection')
            .on(
              'debouncedresize.imageWithTextOverlaySection',
              _.checkForHeaderHeightSubtraction
            );
        }
      });
    };

    this.onSectionUnload = function (container) {
      $(window).off('.imageWithTextOverlaySection');
    };
  })();
  theme.SlideshowSection = new (function () {
    var _ = this;

    _.checkForHeaderHeightSubtraction = function () {
      $('.section-slideshow .height--full-minus-header-height').each(
        function () {
          $(this).height($(window).height() - $('.section-header').height());
        }
      );
    };

    this.onSectionLoad = function (target) {
      $('.slideshow', target).each(function () {
        if (
          $(this).find('.height--full').length &&
          $(this).closest('.section-slideshow').index() == 0
        ) {
          $(this).addClass('height--full-minus-header-height');

          _.checkForHeaderHeightSubtraction();

          $(window)
            .off('debouncedresize.slideshowSection')
            .on(
              'debouncedresize.slideshowSection',
              _.checkForHeaderHeightSubtraction
            );
        }

        $(this)
          .on('init', function () {
            $('.lazyload--manual', this)
              .removeClass('lazyload--manual')
              .addClass('lazyload');
          })
          .slick({
            autoplay: $(this).data('autoplay'),
            fade: $(this).data('transition') != 'slide',
            speed: $(this).data('transition') == 'instant' ? 0 : 750,
            autoplaySpeed: $(this).data('autoplay-speed') * 1000,
            arrows: $(this).data('navigation') == 'arrows',
            dots: $(this).data('navigation') == 'dots',
            pauseOnHover:
              $(this).data('transition') != 'instant' ||
              $(this).data('autoplay-speed') > 2,
            // no pause when quick & instant
            infinite: true,
            useTransform: true,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              '</button>',
            nextArrow:
              '<button type="button" class="slick-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              '</button>',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  fade: $(this).data('transition') == 'instant',
                  // keep instant gif-style on mobile
                  speed: $(this).data('transition') == 'instant' ? 0 : 750,
                  arrows: false,
                  dots: $(this).data('navigation') != 'none',
                },
              },
            ],
          });
      });
    };

    this.onSectionUnload = function (target) {
      $('.slick-slider', target).slick('unslick').off('init');
      $(window).off('.slideshowSection');
    };

    this.onBlockSelect = function (target) {
      $(target)
        .closest('.slick-slider')
        .slick('slickGoTo', $(target).data('slick-index'))
        .slick('slickPause');
    };

    this.onBlockDeselect = function (target) {
      $(target).closest('.slick-slider').slick('slickPlay');
    };
  })();
  theme.GallerySection = new (function () {
    this.onSectionLoad = function (container) {
      var $carouselGallery = $('.gallery--mobile-carousel', container);

      if ($carouselGallery.length) {
        var assessCarouselFunction = function assessCarouselFunction() {
          var isCarousel = $carouselGallery.hasClass('slick-slider');
          var shouldShowCarousel = $(window).width() < 768;

          if (!shouldShowCarousel) {
            $('.lazyload--manual', $carouselGallery)
              .removeClass('lazyload--manual')
              .addClass('lazyload');
          }

          if (isCarousel && !shouldShowCarousel) {
            // Destroy carousel
            // - unload slick
            $carouselGallery.slick('unslick').off('init');
            $carouselGallery
              .find('a, .gallery__item')
              .removeAttr('tabindex')
              .removeAttr('role'); // - re-row items

            var rowLimit = $carouselGallery.data('grid');
            var $currentRow = null;
            $carouselGallery.find('.gallery__item').each(function (index) {
              if (index % rowLimit === 0) {
                $currentRow = $('<div class="gallery__row">').appendTo(
                  $carouselGallery
                );
              }

              $(this).appendTo($currentRow);
            });
          } else if (!isCarousel && shouldShowCarousel) {
            // Create carousel
            // - de-row items
            $carouselGallery.find('.gallery__item').appendTo($carouselGallery);
            $carouselGallery.find('.gallery__row').remove(); // - init carousel

            $carouselGallery
              .on('init', function () {
                $('.lazyload--manual', this)
                  .removeClass('lazyload--manual')
                  .addClass('lazyload');
              })
              .slick({
                autoplay: false,
                fade: false,
                infinite: true,
                useTransform: true,
                arrows: false,
                dots: true,
              });
          }
        };

        assessCarouselFunction();
        $(window).on(
          'debouncedresize.themeSection' + container.id,
          assessCarouselFunction
        );
      }
    };

    this.onSectionUnload = function (container) {
      $(window).off('.themeSection' + container.id);
      $('.slick-slider', container).each(function () {
        $(this).slick('unslick').off('init');
      });
    };

    this.onBlockSelect = function (block) {
      var blockSlideIndex = $(block).data('slick-index');
      $(block)
        .closest('.slick-slider')
        .each(function () {
          $(this).slick('slickGoTo', blockSlideIndex);
        });
    };
  })(); // Lightbox

  theme.fbOpts = function () {
    return {
      overlayColor: '#fff',
      padding: 1,
      margin: $(window).width() > 767 ? 40 : 20,
      overlayOpacity: 0.9,
      onComplete: function onComplete() {
        $('#fancybox-wrap').off('mousewheel.fb'); // do not block scrolling
      },
    };
  };

  theme.CustomRowSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.classUpTextLinks(container);
    };

    this.onSectionUnload = function (container) { };
  })();
  theme.FeaturedCollectionSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.loadCarousels(container);
      theme.ProductBlockManager.loadImages(container);
    };

    this.onSectionUnload = function (container) {
      theme.unloadCarousels(container);
    };
  })();
  theme.FeaturedCollectionsSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.loadCarousels(container);
      theme.ProductBlockManager.loadImages(container);
    };

    this.onSectionUnload = function (container) {
      theme.unloadCarousels(container);
    };
  })();
  theme.ListCollectionsTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.ProductBlockManager.loadImages(container);
    };
  })();

  theme.removeAjaxFromProductForm = function ($form) {
    $form.off('submit');
  };

  theme.HeaderSection = new (function () {
    this.onSectionLoad = function (container) {
      // block focus events targeted at the social icons
      $(container).on(
        'focusin.headerSection focusout.headerSection',
        '.social-links',
        function (e) {
          return false;
        }
      ); // asses focus, and handle transitioning between child elements with a timeout

      var searchFocusOutTimeoutId = -1;
      $(container).on(
        'focusin.headerSection focusout.headerSection',
        '.search-box',
        function (e) {
          if (e.type == 'focusin') {
            clearTimeout(searchFocusOutTimeoutId);
            $(this).closest('.search-box').addClass('focus');
          } else {
            clearTimeout(searchFocusOutTimeoutId);
            searchFocusOutTimeoutId = setTimeout(
              function () {
                $(this).closest('.search-box').removeClass('focus');
              }.bind(this),
              200
            );
          }
        }
      ); // Toggle search

      $(container).on(
        'click.headerSection',
        '.show-search-link, .main-search__close',
        function (e) {
          $('#cover-for-spinner').css('display', 'block');
          $('.main-search__input:first').val('');

          if ($('body').toggleClass('show-search').hasClass('show-search')) {
            setTimeout(function () {
              $('.main-search__input:first').focus();
              $('#cover-for-spinner').css('display', 'none');
            }, 500);
          } else {
            $('.show-search-link:first').focus();
            $('#cover-for-spinner').css('display', 'none');
          }
          return false;
        }
      ); // Close search on escape

      $(container).on(
        'keyup.headerSection',
        '.main-search__input',
        function (e) {
          if (e.keyCode == 27) {
            $('.main-search__close').click();
            $('.main-search__input:first').val('');
          }
        }
      ); /// Live search

      // account / localization
      $('.disclosure', container).each(function () {
        $(this).data('disclosure', new theme.Disclosure($(this)));
      }); // nav

      theme.Navigation.init({
        nav: $('.navigation--main', container),
        proxyTier1Nav: $('.navigation--left', container),
      });

      if (theme.inlineNavigationCheck) {
        theme.inlineNavigationCheck();
        $(window).on(
          'debouncedresize.headerSection',
          theme.inlineNavigationCheck
        );
      }
    };

    this.onSectionUnload = function (container) {
      $(container).off('.headerSection');
      $(window).off('.headerSection');
      $('.disclosure', container).each(function () {
        $(this).data('disclosure').unload();
      });
      theme.Navigation.destroy(
        $('.navigation', container),
        $('.navigation--left', container)
      );
    };
  })();
  theme.FooterSection = new (function () {
    this.onSectionLoad = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });
    };

    this.onSectionUnload = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure').unload();
      });
    };
  })();
  theme.AnnouncementBarSection = new (function () {
    this.onSectionLoad = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });
    };

    this.onSectionUnload = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure').unload();
      });
    };
  })(); // Manage option dropdowns

  theme.productData = {};
  theme.OptionManager = new (function () {
    var _ = this;

    _._getVariantOptionElement = function (variant, $container) {
      return $container.find(
        'select[name="id"] option[value="' + variant.id + '"]'
      );
    };

    _.selectors = {
      container: '.product-detail',
      gallery: '.gallery',
      priceArea: '.price-area',
      submitButton: 'input[type=submit], button[type=submit]',
      multiOption: '.option-selectors',
    };
    _.strings = {
      priceNonExistent: theme.strings.products_variant_non_existent,
      buttonDefault: theme.strings.products_product_add_to_cart,
      buttonNoStock: theme.strings.products_variant_no_stock,
      buttonNoVariant: theme.strings.products_variant_non_existent,
      unitPriceSeparator: theme.strings.products_product_unit_price_separator,
      inventoryNotice: theme.strings.onlyXLeft,
    };

    _._getString = function (key, variant) {
      var string = _.strings[key];

      if (variant) {
        string = string.replace(
          '[PRICE]',
          '<span class="theme-money">' +
          theme.Shopify.formatMoney(variant.price, theme.money_format) +
          '</span>'
        );
      }

      return string;
    };

    _.getProductData = function ($form) {
      var productId = $form.data('product-id');
      var data = null;

      if (!theme.productData[productId]) {
        theme.productData[productId] = JSON.parse(
          document.getElementById('ProductJson-' + productId).innerHTML
        );
      }

      data = theme.productData[productId];

      if (!data) {
        console.log(
          'Product data missing (id: ' + $form.data('product-id') + ')'
        );
      }

      return data;
    };

    (_.getBaseUnit = function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }),
      (_.addVariantUrlToHistory = function (variant) {
        if (variant) {
          var newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            variant.id;
          window.history.replaceState(
            {
              path: newurl,
            },
            '',
            newurl
          );
        }
      });

    _.updateSku = function (variant, $container) {
      $container.find('.sku .sku__value').html(variant ? variant.sku : '');
      $container
        .find('.sku')
        .toggleClass('sku--no-sku', !variant || !variant.sku);
    };

    _.updateBarcode = function (variant, $container) {
      $container
        .find('.barcode .barcode__value')
        .html(variant ? variant.barcode : '');
      $container
        .find('.barcode')
        .toggleClass('barcode--no-barcode', !variant || !variant.barcode);
    };

    _.updateInventoryNotice = function (variant, $container) {
      var inventoryData = _._getVariantOptionElement(variant, $container).data(
        'inventory'
      );
      if (inventoryData) {
        $container
          .find('.product-inventory-notice')
          .removeClass('product-inventory-notice--no-inventory')
          .html(
            _._getString('inventoryNotice').replace(
              '[[ quantity ]]',
              inventoryData
            )
          );
      } else {
        $container
          .find('.product-inventory-notice')
          .addClass('product-inventory-notice--no-inventory')
          .empty();
      }
    };

    _.updatePrice = function (variant, $container) {
      var $priceArea = $container.find(_.selectors.priceArea);
      $priceArea.removeClass('on-sale');

      if (variant) {
        var $newPriceArea = $('<div>');
        var $price = $('<div class="price h4-style">').appendTo($newPriceArea);
        $('<span class="current-price theme-money">')
          .html(theme.Shopify.formatMoney(variant.price, theme.money_format))
          .appendTo($price);

        if (variant.compare_at_price > variant.price) {
          $price.append(' ');
          $('<span class="was-price theme-money">')
            .html(
              theme.Shopify.formatMoney(
                variant.compare_at_price,
                theme.money_format
              )
            )
            .appendTo($price);
          $price.addClass('on-sale');
        }

        if (variant.unit_price_measurement) {
          var $newUnitPriceArea = $('<div class="unit-price">').appendTo(
            $newPriceArea
          );
          $('<span class="unit-price__price theme-money">')
            .html(
              theme.Shopify.formatMoney(variant.unit_price, theme.money_format)
            )
            .appendTo($newUnitPriceArea);
          $('<span class="unit-price__separator">')
            .html(_._getString('unitPriceSeparator'))
            .appendTo($newUnitPriceArea);
          $('<span class="unit-price__unit">')
            .html(_.getBaseUnit(variant))
            .appendTo($newUnitPriceArea);
        }

        $priceArea.html($newPriceArea.html());
      }
    };

    _._updateButtonText = function ($button, string, variant) {
      $button.each(function () {
        var newVal;
        newVal = _._getString('button' + string, variant);

        if (newVal !== false) {
          if ($(this).is('input')) {
            $(this).val(newVal);
          } else {
            $(this).html(newVal);
          }
        }
      });
    };

    _.updateButtons = function (variant, $container) {
      var $button = $container.find(_.selectors.submitButton);

      if (variant && variant.available == true) {
        $button.removeAttr('disabled');
        _._updateButtonText($button, 'Default', variant);
      } else {
        $button.attr('disabled', 'disabled');
        if (variant) {
          _._updateButtonText($button, 'NoStock', variant);
        } else {
          _._updateButtonText($button, 'NoVariant', variant);
        }
      }
    };

    _.initProductOptions = function (originalInput) {
      $(originalInput)
        .not('.theme-init')
        .addClass('theme-init')
        .each(function () {
          var $originalInput = $(this);

          if ($originalInput.is('select')) {
            var productData = _.getProductData($originalInput.closest('form')); // change state for original dropdown

            $originalInput.on(
              'change.themeProductOptions firstrun.themeProductOptions',
              function (e, variant) {
                if ($(this).is('input[type=radio]:not(:checked)')) {
                  return; // handle radios - only update for checked
                }

                var variant = variant;

                if (!variant && variant !== false) {
                  for (var i = 0; i < productData.variants.length; i++) {
                    if (productData.variants[i].id == $(this).val()) {
                      variant = productData.variants[i];
                    }
                  }
                }

                var $container = $(this).closest(_.selectors.container); // update price

                _.updatePrice(variant, $container); // update buttons

                _.updateButtons(variant, $container); // emit an event to broadcast the variant update

                $(window).trigger('cc-variant-updated', {
                  variant: variant,
                  product: productData,
                }); // variant images

                if (variant && variant.featured_media) {
                  $container
                    .find(_.selectors.gallery)
                    .trigger('variantImageSelected', variant);
                } // extra details

                _.updateBarcode(variant, $container);

                _.updateSku(variant, $container);

                _.updateInventoryNotice(variant, $container);

                var $form = $(this).closest('form');

                if ($form.data('enable-history-state') && e.type == 'change') {
                  _.addVariantUrlToHistory(variant);
                } // allow other things to hook on

                $(this).trigger('variantChanged', variant);
              }
            ); // split-options wrapper

            $originalInput
              .closest(_.selectors.container)
              .find(_.selectors.multiOption)
              .on('change.themeProductOptions', 'select', function () {
                var selectedOptions = [];
                $(this)
                  .closest(_.selectors.multiOption)
                  .find('select')
                  .each(function () {
                    selectedOptions.push($(this).val());
                  }); // find variant

                // Emit selected product options
                let event = new CustomEvent('optionUpdate', {
                  detail: selectedOptions,
                });
                document.dispatchEvent(event);

                var variant = false;

                for (var i = 0; i < productData.variants.length; i++) {
                  var v = productData.variants[i];
                  var matchCount = 0;

                  for (var j = 0; j < selectedOptions.length; j++) {
                    if (v.options[j] == selectedOptions[j]) {
                      matchCount++;
                    }
                  }

                  if (matchCount == selectedOptions.length) {
                    variant = v;
                    break;
                  }
                } // trigger change

                if (variant) {
                  $originalInput.val(variant.id);
                }

                $originalInput.trigger('change', variant);
              }); // first-run

            $originalInput.trigger('firstrun');
          }
        });

      function scrollToReviews() {
        var reviewsWidget = document.getElementById('stamped-main-widget');

        window.scrollTo({
          top: reviewsWidget.offsetTop - 215,
          left: 0,
          behavior: 'smooth',
        });
      }

      // Scroll to correct area for reviews
      var stampedBadge = document.querySelector('.stamped-main-badge');
      if (stampedBadge) {
        stampedBadge.addEventListener('click', function (e) {
          e.stopPropagation();
          scrollToReviews();
        });
      }

      // Scroll to fit guide
      var productFitGuide = document.querySelector('.product-fit-guide');
      var howDoesItFitText = document.querySelector('.how-does-it-fit');

      if (howDoesItFitText) {
        howDoesItFitText.addEventListener('click', function (e) {
          window.scrollTo({
            top: productFitGuide.offsetTop - 100,
            left: 0,
            behavior: 'smooth',
          });
        });
      }

//           // Scroll to fit guide (alternative method)
// var productFitGuide = document.querySelector('.product-fit-guide');
// var howDoesItFitText = document.querySelector('.how-does-it-fit');
// var header = document.getElementById('header');

// if (howDoesItFitText && productFitGuide && header) {
//   howDoesItFitText.addEventListener('click', function (e) {
//     var headerHeight = header.offsetHeight;
//     window.scrollTo({
//       top: productFitGuide.offsetTop - headerHeight,
//       left: 0,
//       behavior: 'smooth',
//     });
//   });
// }

      // Add "Write a Review" if there aren't any
      var waitForStampedIO = setInterval(function () {
        var reviewsCaption = document.querySelector('.stamped-badge-caption');

        if (reviewsCaption) {
          clearInterval(waitForStampedIO);

          if (reviewsCaption.textContent === '') {
            reviewsCaption.textContent = 'Write a Review';
          }

          var stampedNewReview = document.querySelector(
            '.stamped-summary-actions-newreview'
          );
          var stampedNewQuestion = document.querySelector(
            '.stamped-summary-actions-newquestion'
          );

          if (stampedNewReview) {
            stampedNewReview.addEventListener('click', function (e) {
              setTimeout(function () {
                scrollToReviews();
              }, 2000);
            });
          }

          if (stampedNewQuestion) {
            stampedNewQuestion.addEventListener('click', function (e) {
              scrollToReviews();
            });
          }
        }
      }, 500);
    };

    _.unloadProductOptions = function (originalInput) {
      $(originalInput)
        .removeClass('theme-init')
        .each(function () {
          $(this).trigger('unloading').off('.themeProductOptions');
          $(this)
            .closest(_.selectors.container)
            .find(_.selectors.multiOption)
            .off('.themeProductOptions');
          theme.removeAjaxFromProductForm($(this).closest('form'));
        });
    };
  })();
  theme.owlCarouselEventList =
    [
      'to',
      'next',
      'prev',
      'destroy',
      'initialized',
      'resized',
      'refreshed',
    ].join('.owl.carousel ') + '.owl.carousel';

  theme.beforeCarouselLoadEventBlockFix = function (carouselEls) {
    $(carouselEls).on(theme.owlCarouselEventList, function (evt) {
      evt.stopPropagation();
    });
  };

  theme.beforeCarouselUnloadEventBlockFix = function (carouselEls) {
    $(carouselEls).off(theme.owlCarouselEventList);
  };

  theme.loadCarousels = function (container) {
    /// Carousels
    $('.carousel', container).each(function () {
      var $this = $(this);

      function getTotalProductBlockWidth() {
        var productBlockTotalWidth = 0;
        $this
          .find(
            $this.hasClass('owl-loaded')
              ? '.owl-item:not(.cloned)'
              : '.product-block'
          )
          .each(function () {
            productBlockTotalWidth += $(this).outerWidth(true);
          });
        return productBlockTotalWidth;
      } // next & prev arrows

      $this
        .closest('.collection-slider')
        .on('click.themeCarousel', '.prev, .next', function (e) {
          e.preventDefault();
          var carousel = $(this)
            .closest('.collection-slider')
            .find('.owl-carousel')
            .data('owl.carousel');

          if ($(this).hasClass('prev')) {
            carousel.prev();
          } else {
            carousel.next();
          }
        }); // create options

      var carouselOptions, isLooping;
      var fixedMode = !$(this).closest('.container--no-max').length;
      $this.toggleClass('carousel--fixed-grid-mode', fixedMode);

      if (fixedMode) {
        var desktopNumPerRow = parseInt(
          $(this)[0].className.match(/per-row-(.)/)[1]
        );
        carouselOptions = {
          margin: 0,
          loop: false,
          autoWidth: false,
          items: 5,
          center: false,
          nav: false,
          dots: false,
          responsive: {
            0: {
              items: desktopNumPerRow < 4 ? 1 : 2,
            },
            480: {
              items: Math.min(2, desktopNumPerRow - 2),
            },
            767: {
              items: desktopNumPerRow - 1,
            },
            1000: {
              items: desktopNumPerRow,
            },
          },
        };
      } else {
        isLooping = getTotalProductBlockWidth() > $this.width();
        carouselOptions = {
          margin: 0,
          loop: isLooping,
          autoWidth: true,
          items: Math.min($this.children().length, 8),
          center: true,
          nav: false,
          dots: false,
        };
      } // init carousel

      var loadCarousel = function loadCarousel() {
        // remove data-src as not in correct format for Owl to parse
        $this.find('[data-src]').each(function () {
          $(this)
            .attr('data-src-temp', $(this).attr('data-src'))
            .removeAttr('data-src');
        }); // fix for event propagation in nested owl carousels

        theme.beforeCarouselLoadEventBlockFix($this); // run after carousel is initialised

        $this.on('initialized.owl.carousel', function () {
          // restore data-src
          $this.find('[data-src-temp]').each(function () {
            $(this)
              .attr('data-src', $(this).attr('data-src-temp'))
              .removeAttr('data-src-temp');
          }); // lazysizes

          $this
            .find('.lazyload--manual')
            .removeClass('lazyload--manual')
            .addClass('lazyload'); // ensure clones are processed from scratch

          theme.ProductBlockManager.loadImages(
            $this.closest('[data-section-type]')
          ); // recalculate widths, after the above's async calls

          setTimeout(function () {
            $this.data('owl.carousel').invalidate('width');
            $this.trigger('refresh.owl.carousel');
          }, 10);
        }); // run after carousel is initialised or resized

        $this.on(
          'initialized.owl.carousel resized.owl.carousel',
          function (evt) {
            // only loop if items do not all fit on screen, in non-fixed mode
            if (!fixedMode && evt.type == 'resized') {
              var shouldLoop = getTotalProductBlockWidth() > $this.width();

              if (shouldLoop != isLooping) {
                // destroy and rebuild carousel with appropriate loop setting
                carouselOptions.loop = shouldLoop;
                isLooping = shouldLoop; // destroy function

                $(evt.target).data('owl.carousel').destroy(); // build again

                $(evt.target).owlCarousel(carouselOptions); // do no more in this callback

                return;
              }
            } // layout fixes

            setTimeout(function () {
              // fixes
              var currentWidth = $this.find('.owl-stage').width();
              var stageIsPartiallyOffScreen = currentWidth > $this.width();

              if (stageIsPartiallyOffScreen) {
                // more elements than fit in viewport
                // resize stage to avoid rounding-error wrapping
                var newWidth = 0;
                $this.find('.owl-item').each(function () {
                  newWidth += $(this).outerWidth(true) + 1;
                });
                $this
                  .find('.owl-stage')
                  .css({})
                  .removeClass('owl-stage--items-fit');
              } else {
                // all elements fit inside viewport
                // centre-align using css, if not full
                $this
                  .find('.owl-stage')
                  .addClass('owl-stage--items-fit')
                  .css({});
              } // previous/next button visibility

              $this
                .closest('.collection-slider')
                .find('.prev, .next')
                .toggleClass('owl-btn-disabled', !stageIsPartiallyOffScreen);
            }, 10);
          }
        ); // run when the contents change, for any reason

        theme.carouselInputIncrementer = theme.carouselInputIncrementer || 0;
        $this
          .on('refreshed.owl.carousel', function () {
            // set a11y attrs to avoid clone items giving duplication errors
            $('.owl-item', this).removeAttr('aria-hidden');
            $('.owl-item.cloned', this)
              .attr('aria-hidden', 'true')
              .each(function () {
                theme.carouselInputIncrementer++;
                var uniquenessSuffix = '_' + theme.carouselInputIncrementer;
                $(this)
                  .find(
                    'form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])'
                  )
                  .each(function () {
                    $(this).attr('id', $(this).attr('id') + uniquenessSuffix);
                  })
                  .attr('data-id-altered', true);
                $(this)
                  .find('label[for]:not([data-id-altered])')
                  .each(function () {
                    $(this).attr('for', $(this).attr('for') + uniquenessSuffix);
                  })
                  .attr('data-id-altered', true);
              });
          })
          .addClass('owl-carousel')
          .owlCarousel(carouselOptions);
      };

      loadCarousel();
    });
  };

  theme.unloadCarousels = function (container) {
    $('.collection-slider', container).off('.themeCarousel');
    $('.slick-slider', container).slick('unslick');
    theme.beforeCarouselUnloadEventBlockFix($('.owl-carousel', container));
    $('.owl-carousel', container).each(function () {
      $(this).data('owl.carousel').destroy();
    });
  };

  theme.saveGridStreamChoice = function (type) {
    var cfg = {
      expires: 1,
      path: '/',
      domain: window.location.hostname,
    };
    $.cookie('gridstream', type, cfg);
  };

  theme.getGridStreamChoice = function () {
    return $.cookie('gridstream');
  }; // Enables any images inside a container

  theme.awakenImagesFromSlumber = function ($cont) {
    $cont.find('.lazyload--manual:not(.lazyload)').addClass('lazyload');
  }; // Process product block layout

  theme.ProductBlockManager = new (function () {
    var _ = this;

    _.loadImages = function (container) {
      var container = container;

      if (typeof container === 'undefined') {
        container = $('body');
      }

      _.afterImagesResized(container);
    };

    _.afterImagesResized = function (container) {
      var container = container;

      if (typeof container === 'undefined') {
        container = $('body');
      } // All titles must line up

      $(
        '.collection-listing .product-list.product-list--image-shape-natural',
        container
      ).each(function () {
        if (
          $(window).width() >= 768 ||
          $(this).closest('.carousel').length > 0
        ) {
          var tallest = 0;
          $(this)
            .find(
              '.product-block.detail-mode-permanent .image-cont .primary-image img'
            )
            .each(function () {
              if ($(this).height() > tallest) tallest = $(this).height();
            });
          $(this)
            .find(
              '.product-block.detail-mode-permanent .image-cont .primary-image'
            )
            .css('min-height', tallest);
        } else {
          $(this)
            .find(
              '.product-block.detail-mode-permanent .image-cont .primary-image'
            )
            .css('min-height', '');
        }
      }); // undo for list view

      $(
        '.collection-listing-stream .product-list .product-block.detail-mode-permanent .image-cont .primary-image'
      ).css('min-height', '');

      _.alignProductBlockHeights(container);
    };

    _.alignProductBlockHeights = function (container) {
      var container = container;

      if (typeof container === 'undefined') {
        container = $('body');
      } // All product blocks must be the same height, for quick-buy alignment

      $('.collection-listing .product-list', container).each(function () {
        if (
          $(window).width() >= 768 ||
          $(this).closest('.carousel').length > 0
        ) {
          var tallest = 0;
          $(this)
            .find('.product-block .block-inner .block-inner-inner')
            .each(function () {
              if ($(this).height() > tallest) tallest = $(this).height();
            });
          $(this)
            .find('.product-block .block-inner')
            .css('min-height', tallest);
        } else {
          $(this).find('.product-block .block-inner').css('min-height', '');
        }
      });
    };
  })();

  theme.initToggleTargets = function (container) {
    $('a[data-toggle-target]:not(.toggle-init)', container)
      .addClass('toggle-init')
      .each(function () {
        var $target = $($(this).data('toggle-target'));
        $(this)
          .find('.state')
          .html(
            $target.is(':visible') && !$target.hasClass('height-hidden')
              ? '-'
              : '+'
          );
      });
  }; // Style any text-only links nicely

  theme.classUpTextLinks = function (container) {
    $('.user-content a:has(img)', container).addClass('image-link');
  }; /// Select2 with swatches

  // Sort the options
  theme.select2 = {
    transitionOutDelay: 250,
    // match CSS transition for transition out
    init: function init($els, config) {
      var standardSelectOptions = {
        minimumResultsForSearch: Infinity,
        width: 'computedstyle',
      };
      var swatchSelectOptions = {
        minimumResultsForSearch: Infinity,
        templateResult: theme.select2.swatchSelect2OptionTemplate,
        templateSelection: theme.select2.swatchSelect2OptionTemplate,
        width: 'computedstyle',
      };

      if (typeof config !== 'undefined') {
        standardSelectOptions = $.extend(standardSelectOptions, config);
        swatchSelectOptions = $.extend(swatchSelectOptions, config);
      }

      // Get potential product group ID from Shopify metafield
      const coordinateGroup = window.Shopify.theme.coordinateGroup || '';

      // Get stored product options for session
      let storedOptions = JSON.parse(sessionStorage.getItem('storedOptions'));

      // Remove item if no match
      if (!storedOptions || storedOptions.group !== coordinateGroup) {
        sessionStorage.removeItem('storedOptions');
        storedOptions = null;
      }

      // Listen for product options updates and get the array of data
      document.addEventListener('optionUpdate', (event) => {
        // Get options from event detail
        const options = event.detail;

        if (coordinateGroup && options.length) {
          // Make an object with the group ID and product options,
          // if they are selected
          const storedObj = JSON.stringify({
            group: coordinateGroup,
            0: options[0].includes('Select') ? null : options[0],
            1: options[1].includes('Select') ? null : options[1],
          });

          // Set object in storage
          sessionStorage.setItem('storedOptions', storedObj);
        }
      });

      // Make nothing selected by default
      var sizeSelectElement = document.querySelector('#SingleOptionSelector-0');

      if (!document.querySelector('.select2-results__option--select-a-size')) {
        // Create select a size option
        var selectSizeOption = document.createElement('option');
        selectSizeOption.classList.add(
          'select2-results__option--select-a-size'
        );
        selectSizeOption.value = 'Select a Size';
        selectSizeOption.text = 'Select a Size';

        if (sizeSelectElement) {
          // Add to <select> and select it
          sizeSelectElement.add(selectSizeOption, sizeSelectElement.options[0]);
          sizeSelectElement.selectedIndex = 0;
  
          // If we have a stored option and a matching option value, set it
          if (
            storedOptions &&
            storedOptions['0'] &&
            sizeSelectElement.querySelector(
              `option[value="${storedOptions['0']}"]`
            )
          ) {
            sizeSelectElement.value = storedOptions['0'];
          }
  
          sizeSelectElement.dispatchEvent(
            new Event('change', {
              view: window,
              bubbles: true,
              cancelable: true,
            })
          );
        }
        var widthSelectElement = document.querySelector(
          '#SingleOptionSelector-1'
        );
        if (widthSelectElement) {
          // If there's more than one width, don't autoselect
          if (widthSelectElement.querySelectorAll('option').length > 1) {
            var selectWidthOption = document.createElement('option');
            selectWidthOption.classList.add(
              'select2-results__option--select-a-width'
            );
            selectWidthOption.value = 'Select a Width';
            selectWidthOption.text = 'Select a Width';

            // Add to <select> and select it
            widthSelectElement.add(
              selectWidthOption,
              widthSelectElement.options[0]
            );
            widthSelectElement.selectedIndex = 0;

            // If we have a stored option and a matching option value, set it
            if (
              storedOptions &&
              storedOptions['1'] &&
              widthSelectElement.querySelector(
                `option[value="${storedOptions['1']}"]`
              )
            ) {
              widthSelectElement.value = storedOptions['1'];
            }

            // Wait for previous event dispatch
            setTimeout(() => {
              widthSelectElement.dispatchEvent(
                new Event('change', {
                  view: window,
                  bubbles: true,
                  cancelable: true,
                })
              );
            }, 1);

            document
              .querySelectorAll('#clickyboxes-SingleOptionSelector-1 li a')
              .forEach(function (element) {
                if (element.classList.contains('active')) {
                  element.classList.remove('active');
                }

                if (element.classList.contains('unavailable')) {
                  element.classList.remove('unavailable');
                }
              });
          }
        }
      }

      // Add size alias to page if it exists
       function addSizeAlias() {
         console.log('entering sa');
        // Add size alias
        var widthAliasObject = JSON.parse(
          document.getElementById('size-alias').innerText
        );
        console.log('s data: ' + widthAliasObject);
         
        // Loop through size options
        var widthOptions = document.querySelectorAll(
          '#clickyboxes-SingleOptionSelector-0 li a'
        );
        widthOptions.forEach(function (widthOptions) {
          // Make inline size alias element
          var widthAliasElement = document.createElement('span');
          widthAliasElement.classList.add('size-alias--inline');

          for (const [key, value] of Object.entries(widthAliasObject)) {
            // Check fo sizeAlias that corresponds with regular size
            var regularWidth = widthOptions.textContent;
            var widthAlias;

            if (regularWidth === key) {
              if(value == ''){

              }
              
              widthAlias = value;
              if (widthAlias.split('=')[1]) {
                widthAliasElement.innerHTML = widthAlias.split('=')[1];
                widthOptions.append(widthAliasElement);
              } 
              if (widthAlias !== '') {
                widthOptions.innerText = widthAlias;
              }
            }
          }

          widthOptions.innerHTML = `<span class="width-span"><p class="width-p">${widthOptions.innerHTML.toLowerCase()}</p></span>`;
        });
      } 
      function addSizeAliasss() {
        // Add size alias
        var sizeAliasObject = JSON.parse(
          document.getElementById('size-alias').innerText
        );

        // Loop through size options
        if (document.querySelectorAll('.select2-results__option').length > 0) {
          var sizeSelectOptions = document.querySelectorAll(
            '.select2-results__option'
          );

          sizeSelectOptions.forEach(function (sizeSelectOptions) {
            // Make inline size alias element
            var sizeAliasElement = document.createElement('span');
            sizeAliasElement.classList.add('size-alias--inline');

            for (const [key, value] of Object.entries(sizeAliasObject)) {
              // Check fo sizeAlias that corresponds with regular size
              var regularSize = sizeSelectOptions.textContent;
              var sizeAlias;

              if (regularSize === key) {
                sizeAlias = value;

                // do not print if value is null
                if (sizeAlias != 'NULL') {
                  sizeAliasElement.innerHTML = sizeAlias;
                  sizeSelectOptions.append(sizeAliasElement);
                  sizeSelectOptions.classList.add(
                    'select2-results__option--use-alias'
                  );
                }
              }
            }

            // Wrap in a span for better unavailable styling
            sizeSelectOptions.innerHTML = `<span class="select-span">${sizeSelectOptions.innerHTML}</span>`;
          });
        } else {
          var selectedSizeOption = document.querySelector(
            '.select2-selection__rendered'
          );

          // Make inline size alias element
          var sizeAliasElement = document.createElement('span');
          sizeAliasElement.classList.add('size-alias--inline');

          for (const [key, value] of Object.entries(sizeAliasObject)) {
            var regularSize = selectedSizeOption.textContent;
            var sizeAlias;

            if (regularSize === key) {
              sizeAlias = value;
              sizeAliasElement.innerHTML = sizeAlias;
              selectedSizeOption.append(sizeAliasElement);
              selectedSizeOption.classList.add(
                'select2-results__option--use-alias'
              );
            }
          }
        }
      }

      // Add width alias to page if it exists
      function addWidthAlias() {
        // Add size alias
        var wa = document.getElementById('width-alias');
        if (wa) {
            var widthAliasObject = JSON.parse(
              document.getElementById('width-alias').innerText
            );
    
            // Loop through size options
            var widthOptions = document.querySelectorAll(
              '#clickyboxes-SingleOptionSelector-1 li a'
            );
            widthOptions.forEach(function (widthOptions) {
              // Make inline size alias element
              var widthAliasElement = document.createElement('span');
              widthAliasElement.classList.add('width-alias--inline');
    
              for (const [key, value] of Object.entries(widthAliasObject)) {
                // Check fo sizeAlias that corresponds with regular size
                var regularWidth = widthOptions.textContent;
                var widthAlias;
    
                if (regularWidth === key) {
                  widthAlias = value;
    
                  if (widthAlias.split('=')[1]) {
                    
                    widthAliasElement.innerHTML = widthAlias.split('=')[1];
                    widthOptions.append(widthAliasElement);
                  } else if (widthAlias !== '') {
                    
                    widthOptions.innerText = widthAlias;
                  }
                }
              }
              
              //console.log('width alias: ' + widthAlias.split('=')[1]);
              
              var wa = undefined;
              
              try {
                 wa = widthAlias.split('=')[1];
              }
              catch(err) {
                
              }
              
              if (wa === undefined || wa === null) {
                
              } else {
                 widthOptions.innerHTML = `<span class="width-span"><p class="width-p">${widthAlias.split('=')[1]}</p></span>`;
              }
              
              
              
            
            });
        }

      }

      // Get option quantities
      var optionQuantities = '';

      // Get option availability
      var optionAvailability = '';

      try {
          optionQuantities = JSON.parse(
            document.getElementById('option-quanitites').innerText
          );
      }
      catch(err) {
      
      }

      try {
            optionAvailability = JSON.parse(
              document.getElementById('option-availability').innerText
            );
      }
      catch(err) {
        
      }

      // Check size availability
      function checkSizeAvailability() {
        // If width is selected, check for sizes
        if (
          document.querySelector('#clickyboxes-SingleOptionSelector-1 .active') && optionQuantities != '' && optionAvailability != ''
        ) {
          // Get width
          const selectedWidth = document
            .querySelector('#clickyboxes-SingleOptionSelector-1 .active')
            .getAttribute('data-value');
          document
            .querySelectorAll('.select2-results__option')
            .forEach((sizeOptionElement) => {
              const sizeValue = sizeOptionElement
                .querySelector('.select-span')
                .innerHTML.split('<span')[0];
              const quantity =
                optionQuantities[`${sizeValue}_${selectedWidth}`];
              const availability =
                optionAvailability[`${sizeValue}_${selectedWidth}`];

              // Check availability and quantity
              availability === 'Always' || availability === 'Ok' || quantity > 0
                ? sizeOptionElement.classList.remove('unavailable')
                : sizeOptionElement.classList.add('unavailable');
            });
        } else {
          // Define an empty array for in stock variants
          let inStockSizes = [];

          // Convert object to array and loop through it
          Object.entries(optionQuantities).forEach((item) => {
            // Find values that are not zero and push to new array
            if (item[1] > 0) {
              inStockSizes.push(item);
            }
          });

          // Add availability to array as well
          Object.entries(optionAvailability).forEach((item) => {
            // Find values that are not zero and push to new array
            if (item[1] === 'Always' || item[1] === 'Ok') {
              inStockSizes.push(item);
            }
          });

          // Remove duplicates
          inStockSizes = Array.from(
            new Set(
              // Grab just the first value of the label, before the underscore
              inStockSizes.map((item) => item[0].split('_')[0])
            )
          );

          // Get size options
          const sizeOpts = document.querySelectorAll(
            '.select2-results__option'
          );

          // Loop through options
          sizeOpts.forEach((opt) => {
            // Get option value, bail if there is none
            const sizeVal = opt
              .querySelector('.select-span')
              .innerHTML.split('<span')[0];

            // If we don't have it in our in stock variants array, remove it
            !inStockSizes.includes(sizeVal)
              ? opt.classList.add('unavailable')
              : opt.classList.remove('unavailable');
          });

          // Check selected size as well
          const selectedSizeVal = document.querySelector(
            '.select2-selection__rendered'
          );
          const selectedSizeValTrimmed =
            selectedSizeVal.innerHTML.split('<span')[0];

          // If we don't have it in our in stock variants array, remove it
          if (selectedSizeVal.getAttribute('title') !== 'Select a Size') {
            !inStockSizes.includes(selectedSizeValTrimmed)
              ? selectedSizeVal.closest('.select2').classList.add('unavailable')
              : selectedSizeVal
                .closest('.select2')
                .classList.remove('unavailable');
          }
        }
      }

      // Check width availability
      window.checkWidthAvailability = function checkWidthAvailability() {
        // If size is selected
        var selectedSize = document.querySelector(
          '#select2-SingleOptionSelector-0-container'
        );
        if (selectedSize && optionQuantities != '' && optionAvailability != '') {
          selectedSize = selectedSize.innerHTML.split('<span')[0].trim();
          if (selectedSize !== 'Select a Size') {
            document
              .querySelectorAll('#clickyboxes-SingleOptionSelector-1 a')
              .forEach((widthOptionElement) => {
                var widthValue = widthOptionElement.getAttribute('data-value');
                var quantity =
                  optionQuantities[`${selectedSize}_${widthValue}`];
                var availability =
                  optionAvailability[`${selectedSize}_${widthValue}`];

                // Check availability and quantity
                availability === 'Always' ||
                  availability === 'Ok' ||
                  quantity > 0
                  ? widthOptionElement.classList.remove('unavailable')
                  : widthOptionElement.classList.add('unavailable');
              });

            // Autoselect width if there's only one option left
            if (
              document.querySelectorAll(
                '#clickyboxes-SingleOptionSelector-1 li a.unavailable'
              ).length ===
              document.querySelectorAll(
                '#clickyboxes-SingleOptionSelector-1 li a'
              ).length -
              1
            ) {
              document
                .querySelectorAll('#clickyboxes-SingleOptionSelector-1 li a')
                .forEach(function (widthOptions) {
                  if (!widthOptions.classList.contains('unavailable')) {
                    widthOptions.setAttribute('selected', 'selected');

                    document
                      .querySelector(
                        '#SingleOptionSelector-1 option[value="' +
                        widthOptions.getAttribute('data-value') +
                        '"]'
                      )
                      .setAttribute('selected', 'selected');

                    // Update value and hidden select
                    const widthSelect = document.getElementById(
                      'SingleOptionSelector-1'
                    );
                    widthSelect.value = widthOptions.getAttribute('data-value');

                    widthSelect.dispatchEvent(
                      new Event('change', {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                      })
                    );

                    widthOptions.classList.add('active');
                  }
                });
            }
          }
        } else {
          // Define an empty array for in stock variants
          let inStockWidths = [];

          // Convert object to array and loop through it
          Object.entries(optionQuantities).forEach((item) => {
            // Find values that are not zero and push to new array
            if (item[1] > 0) {
              inStockWidths.push(item);
            }
          });

          // Add availability to array as well
          Object.entries(optionAvailability).forEach((item) => {
            // Find values that are not zero and push to new array
            if (item[1] === 'Always' || item[1] === 'Ok') {
              inStockWidths.push(item);
            }
          });

          // Remove duplicates
          inStockWidths = Array.from(
            new Set(
              // Grab just the second value of the label, after the underscore
              inStockWidths.map((item) => item[0].split('_')[1])
            )
          );

          // Get width options
          var widthOpts = document.querySelectorAll(
            '#clickyboxes-SingleOptionSelector-1 li a'
          );

          // Loop through options
          widthOpts.forEach((opt) => {
            // Get option value, bail if there is none
            var widthVal = opt.getAttribute('data-value');

            // If we don't have it in our in stock variants array, remove it
            !inStockWidths.includes(widthVal)
              ? opt.classList.add('unavailable')
              : opt.classList.remove('unavailable');
          });

          // Autoselect width if there's only one option left
          if (
            document.querySelectorAll(
              '#clickyboxes-SingleOptionSelector-1 li a.unavailable'
            ).length ===
            widthOpts.length - 1
          ) {
            document
              .querySelectorAll('#clickyboxes-SingleOptionSelector-1 li a')
              .forEach(function (widthOptions) {
                if (!widthOptions.classList.contains('unavailable')) {
                  widthOptions.setAttribute('selected', 'selected');
                  document
                    .querySelector(
                      '#SingleOptionSelector-1 option[value="' +
                      widthOptions.getAttribute('data-value') +
                      '"]'
                    )
                    .setAttribute('selected', 'selected');

                  // Update value and hidden select
                  const widthSelect = document.getElementById(
                    'SingleOptionSelector-1'
                  );
                  widthSelect.value = widthOptions.getAttribute('data-value');

                  widthSelect.dispatchEvent(
                    new Event('change', {
                      view: window,
                      bubbles: true,
                      cancelable: true,
                    })
                  );

                  widthOptions.classList.add('active');
                }
              });
          }
        }
      };

      // Run on page load
      checkWidthAvailability();
      addWidthAlias();
      
      // Sort size options
      Array.from(document.querySelectorAll('#SingleOptionSelector-0 option'))
        .map((optionElement) => {
          return {
            value: optionElement.value,
            sortValue: parseFloat(optionElement.value.replace(/^\D/g, '')),
            elementReference: optionElement,
          };
        })
        .sort((option1, option2) => {
          return option1.sortValue - option2.sortValue;
        })
        .forEach((sortedOption) => {
          sizeSelectElement.appendChild(sortedOption.elementReference);
        });

      $els
        .not('.select2-hidden-accessible')
        .each(function () {
          // init
          $(this).select2(
            $(this).data('colour-swatch')
              ? swatchSelectOptions
              : standardSelectOptions
          );

          // If we have a WXX label, we might need to fix it
          const label = this.nextElementSibling.querySelector(
            '.select2-selection__rendered'
          );
          const labelText = label ? label.textContent.trim() : '';

          if (/^W[0-9]?[0-9]$/.test(labelText)) {
            label.textContent = labelText.split('W')[1];
          }

          checkWidthAvailability();
          addSizeAlias();
          checkSizeAvailability();
        })
        .on('select2:open', function (e) {
          // transition in
          var $resCon = $(this)
            .data('select2')
            .$results.closest('.select2-dropdown')
            .addClass('select2-dropdown--pre-reveal');
          setTimeout(function () {
            $resCon.addClass('select2-dropdown--enable-trans');
            setTimeout(function () {
              $resCon.removeClass('select2-dropdown--pre-reveal');
              addSizeAlias();
              checkSizeAvailability();
            }, 10);
          }, 10);
        })
        .on('select2:closing', function (e) {
          // handle transitions
          var $select = $(this);
          var $resCon = $select
            .data('select2')
            .$results.closest('.select2-dropdown'); // ensure no other transitions in progress

          clearTimeout($select.data('select2TransOutTimeoutId')); // first time through, begin transition and trigger again

          if (!$resCon.hasClass('select2-dropdown--pre-close')) {
            $resCon.addClass('select2-dropdown--pre-close');
            $select.data(
              'select2TransOutTimeoutId',
              setTimeout(function () {
                $select.select2('close');
              }, theme.select2.transitionOutDelay)
            );
            return false;
          }
        })
        .on('select2:close', function (e) {
          // reset transitions
          $(this)
            .data('select2')
            .$results.closest('.select2-dropdown')
            .removeClass(
              'select2-dropdown--enable-trans select2-dropdown--pre-close'
            );
          addSizeAlias();
          checkSizeAvailability();
          checkWidthAvailability();

          if (
            document.querySelector(
              '#clickyboxes-SingleOptionSelector-1 .active'
            )
          ) {
            // Get width
            const selectedWidth = document
              .querySelector('#clickyboxes-SingleOptionSelector-1 .active')
              .getAttribute('data-value');

            // Check selected size as well
            const selectedSizeValue = document.querySelector(
              '.select2-selection__rendered'
            );
            const selectedSizeValueTrimmed =
              selectedSizeValue.innerHTML.split('<span')[0];
            const selectedQuantity =
              optionQuantities[`${selectedSizeValueTrimmed}_${selectedWidth}`];
            const selectedAvailability =
              optionAvailability[
              `${selectedSizeValueTrimmed}_${selectedWidth}`
              ];

            if (selectedSizeValue.getAttribute('title') !== 'Select a Size') {
              selectedAvailability === 'Always' ||
                selectedAvailability === 'Ok' ||
                selectedQuantity > 0
                ? selectedSizeValue
                  .closest('.select2')
                  .classList.remove('unavailable')
                : selectedSizeValue
                  .closest('.select2')
                  .classList.add('unavailable');
            }
          }
        });
    },
    destroyAllIn: function destroyAllIn($container) {
      theme.select2.destroy($('select[data-select2-id]', $container));
    },
    destroy: function destroy($els) {
      $els.select2('destroy').off('select2:open select2:closing select2:close');
    },
    swatchSelect2OptionTemplate: function swatchSelect2OptionTemplate(state) {
      if (state.id) {
        var colourKey = removeDiacritics(state.id)
          .toLowerCase()
          .replace(/'/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/-*$/, '');
        return $(
          [
            '<div class="swatch-option">',
            '<span class="swatch-option__nugget bg-',
            colourKey,
            '"></span>',
            '<span class="swatch-option__label">',
            state.text,
            '</span>',
            '</div>',
          ].join('')
        );
      } else {
        return $(
          [
            '<div class="swatch-option swatch-option--all">',
            '<span class="swatch-option__label">',
            state.text,
            '</span>',
            '</div>',
          ].join('')
        );
      }
    },
  }; // dom ready

  $(function ($) {
    var $ = $; // keep this ref local

    $(document).on('keyup.themeTabCheck', function (evt) {
      if (evt.keyCode === 9) {
        $('body').addClass('tab-used');
        $(document).off('keyup.themeTabCheck');
      }
    }); // Return elements that have an ancestor/parent matching the supplied selector

    $.fn.hasAncestor = function (a) {
      return this.filter(function () {
        return $(this).closest(a).length > 0;
      });
    }; // Side up and remove

    $.fn.slideUpAndRemove = function (speed) {
      if (typeof speed === 'undefined') speed = 200;
      $(this).each(function () {
        $(this).slideUp(speed, function () {
          $(this).remove();
        });
      });
    }; /// Reusable function to expand/contract a div

    $(document).on('click', 'a[data-toggle-target]', function (e) {
      var $target = $($(this).data('toggle-target'));

      if ($target.hasClass('height-hidden')) {
        $target.hide().removeClass('height-hidden');
      }

      $(this)
        .find('.state')
        .html($target.is(':visible') ? '+' : '-');
      $target.slideToggle(200);
      e.preventDefault();
    }); // Redirect dropdowns

    $(document).on('change', 'select.navdrop', function () {
      window.location = $(this).val();
    }); // General purpose lightbox

    $('a[rel="fancybox"]').fancybox(
      $.extend({}, theme.fbOpts(), {
        titleShow: false,
      })
    ); /// Mobile nav

    $(document).on('click', '.mobile-nav-toggle', function (e) {
      e.preventDefault();
      $('body').toggleClass('reveal-mobile-nav');
    }); /// General window shade

    if (theme.settings.prod_thumb_detail_show) {
      // utility function for quickbuy (closes all quickbuys in passed blocks, in a collection grid)
      var contractDetail = function contractDetail($blocks, speed) {
        if ($blocks.length > 0) {
          $blocks.removeClass('expanded');
          $blocks
            .find('.quickbuy-container')
            .stop()
            .animate(
              {
                height: 0,
              },
              speed,
              function () {
                $(this).find('.inner').empty();
                $(".quickbuy-container").removeClass("quickbuy-active");
                $("body").removeClass("quickbuy-open");
              }
            );
          $blocks.stop().each(function () {
            $(this).animate(
              {
                paddingBottom: 0,
              },
              speed
            );
          });
        }
      }; // quick buy - managing slide-down quickbuy in both grids and carousels

      // You also need to know where to scroll to
      var saveCollectionPageData = function saveCollectionPageData() {
        $('.collection-listing-stream .product-block').each(function () {
          $(this).data('offsetTop', $(this).offset().top);
        });
        $('.collection-listing').each(function () {
          var $blocks = $(this).find('.product-block');
          if ($blocks.length <= 1) return true; // Skip for empty colls

          var row = 0;
          var currTop = 0; // Heights are fixed. Check two in case somebody has expanded one...

          var blockHeight = Math.min(
            $blocks.first().outerHeight(),
            $($blocks[1]).outerHeight()
          );
          var blockPageOffset = $blocks.first().offset().top;
          $blocks.each(function (index) {
            var currOffsetTop = $(this).offset().top;

            if (index == 0) {
              currTop = currOffsetTop;
            } else {
              if (currOffsetTop > currTop) {
                row++;
                currTop = currOffsetTop;
              }
            }

            $(this).data({
              offsetTop: blockPageOffset + row * blockHeight,
            });
          });
        });
      }; // End of code specific to collection-page slide-downs

      var droppyDownAnimSpeed = 500;
      $(document).on(
        'click',
        '.product-list .product-block:not(.collection-block):not(.main-search-result) .product-link:not(product-link--no-qb)',
        function () {
          var pageWidth = $(window).width();
          var productUrl = $(this).attr('href'); // Only show dropdown if screen is large enough for it to be useful

          if (pageWidth > 767) {
            // cancel current request if one exists
            if (theme.currentQuickbuyRequest) {
              theme.currentQuickbuyRequest.abort();
            }

            var $block = $(this).closest('.product-block');
            var $detailCont = null;
            var $quickbuyCont = null;
            var $slider = $(this).closest('.collection-slider');
            var $sliderRow = null; // do different things if it's inside a slideshow

            if ($slider.length > 0) {
              $sliderRow = $slider.closest('.collection-slider-row'); // slider without detail

              if ($sliderRow.find('.quickbuy-container').length === 0) {
                return;
              }

              $quickbuyCont = $sliderRow.find('.quickbuy-container');
            } else {
              $quickbuyCont = $block.find('.quickbuy-container');
            }

            $detailCont = $quickbuyCont.find('.inner'); // toggle active class on block

            if ($block.toggleClass('expanded').hasClass('expanded')) {
              // expanding
              if ($slider.length > 0) {
                // if another block is expanded, remove its expanded class
                var noneExpanded =
                  $slider
                    .find('.product-block.expanded')
                    .not($block)
                    .removeClass('expanded').length === 0; // if expanding from empty, set initial detail container height to 0

                if (noneExpanded) {
                  $quickbuyCont.height(0);
                } else {
                  // unload existing quickbuy
                  theme.OptionManager.unloadProductOptions(
                    $('[name="id"]', $quickbuyCont)
                  );
                  $('.gallery', $quickbuyCont).off(this.namespace);
                  $('.slideshow', $quickbuyCont).slick('unslick');
                } // what to adjust when details change size

                $quickbuyCont.off('changedsize').on('changedsize', function () {
                  $quickbuyCont.stop().animate(
                    {
                      height: $detailCont.outerHeight(),
                    },
                    droppyDownAnimSpeed
                  );
                });
              } else {
                // close expanded siblings
                var $expandedSiblings = $block.siblings('.expanded');
                $expandedSiblings.each(function () {
                  contractDetail($(this), 0); // unload existing quickbuy

                  theme.OptionManager.unloadProductOptions(
                    $('[name="id"]', this)
                  );
                  theme.destroyProductGallery(this);
                }); // what do adjust when details change size

                $quickbuyCont.off('changedsize').on('changedsize', function () {
                  // check expanded class in case it's mid close transition
                  if ($block.hasClass('expanded')) {
                    var targetHeight = $detailCont.outerHeight(); // slide down instantly if a neighbour is expanded

                    var speed =
                      $expandedSiblings.length > 0 ? 0 : droppyDownAnimSpeed;
                    $block.stop().animate(
                      {
                        paddingBottom: targetHeight + 20,
                      },
                      speed
                    ); // extra for gap underneath

                    $quickbuyCont.stop().animate(
                      {
                        height: targetHeight,
                      },
                      speed
                    );
                  }
                });
              } // a little hack to make sure everything lines up

              if (window.SPR) {
                theme.ProductBlockManager.alignProductBlockHeights();
              } // add spinner

              $detailCont.html('<div class="loading-spinner"></div>');
              $quickbuyCont.trigger('changedsize'); // load in content

              var url = $(this).attr('href');
              url +=
                url.indexOf('?') >= 0 ? '&view=_lightbox' : '?view=_lightbox';
              theme.currentQuickbuyRequest = $.get(url, function (response) {
                var $newDetail = $('<div>' + response + '</div>').find(
                  '.product-detail'
                ); // convert to quickbuy content

                $newDetail.find('.more').attr('href', productUrl);
                $newDetail
                  .find('.detail .title')
                  .wrapInner($('<a>').attr('href', productUrl));
                $newDetail
                  .find('.show-gallery')
                  .removeClass('show-gallery')
                  .attr('href', productUrl);
                $detailCont.html($newDetail); // dpb if present

                if (
                  Shopify.PaymentButton &&
                  $quickbuyCont.find('.shopify-payment-button').length
                ) {
                  // resize after loading extra payment buttons
                  var _f = null;

                  _f = function f() {
                    document.removeEventListener(
                      'shopify:payment_button:loaded',
                      _f
                    );
                    $quickbuyCont.trigger('changedsize');
                  };

                  document.addEventListener(
                    'shopify:payment_button:loaded',
                    _f
                  );
                  Shopify.PaymentButton.init();
                } // the order of these is important:

                theme.initProductGallery($quickbuyCont); // 1

                $quickbuyCont
                  .find('[name="id"]')
                  .trigger('optionate') // 2
                  .on('variantChanged', function () {
                    $quickbuyCont.trigger('changedsize'); // (4)
                  });
                $quickbuyCont.trigger('changedsize'); // 3
              }).always(function () {
                theme.currentQuickbuyRequest = false;
              }); // enable close button

              $quickbuyCont.find('.close-detail').removeAttr('tabindex'); // scroll to appropriate position
              // qb: top of quick buy
              // bl: top of product block

              var scrollMode = 'qb';
              var scrollOffset = -120;

              if ($('.section-header').css('position') == 'sticky') {
                scrollOffset -= $('.section-header').height();
              }

              if (scrollMode == 'qb') {
                $('html:not(:animated),body:not(:animated)').animate(
                  {
                    scrollTop: $quickbuyCont.offset().top + scrollOffset,
                  },
                  500
                );
              } else {
                if ($slider.length > 0) {
                  // simple for slider
                  $('html:not(:animated),body:not(:animated)').animate(
                    {
                      scrollTop: $block.offset().top,
                    },
                    500
                  );
                } else {
                  // need to use top of block when no quickbuys are visible
                  saveCollectionPageData();
                  var offsetTop =
                    typeof $block.data('offsetTop') !== 'undefined'
                      ? $block.data('offsetTop')
                      : $block.offset().top;
                  $('html:not(:animated),body:not(:animated)').animate(
                    {
                      scrollTop: offsetTop + scrollOffset,
                    },
                    500
                  );
                }
              }
            } else {
              // close
              if ($slider.length > 0) {
                // collapse detail container
                $quickbuyCont.stop().animate(
                  {
                    height: 0,
                  },
                  droppyDownAnimSpeed,
                  function () {
                    // remove details
                    $detailCont.empty();
                  }
                );
              } else {
                contractDetail($block, droppyDownAnimSpeed);
              } // scroll to top of closing block

              var scrollUpOffset = -140;
              $('html:not(:animated),body:not(:animated)').animate(
                {
                  scrollTop: $block.offset().top + scrollUpOffset,
                },
                500
              ); // disable close button

              $quickbuyCont.find('.close-detail').attr('tabindex', '-1');
            }

            return false;
          }
        }
      ); // Close button event

      $(document).on('click', '.quickbuy-container .close-detail', function () {
        var $slider = $(this).closest('.collection-slider-row');

        if ($slider.length) {
          $slider
            .find('.product-block.expanded .product-link:first')
            .trigger('click');
        } else {
          $(this)
            .closest('.product-block')
            .find('.product-link:first')
            .trigger('click');
        }

        return false;
      });
    } /// Collection slider

    jQuery.fn.reverse = [].reverse; // Genius deserves credit: http://stackoverflow.com/questions/1394020/jquery-each-backwards
    /// Event for initialising options

    // load any images that aren't inside a section
    var $nonSectionedProductLists = $(
      '.product-list, .collection-listing'
    ).filter(function () {
      return $(this).closest('[data-section-type]').length == 0;
    });

    if ($nonSectionedProductLists.length) {
      theme.ProductBlockManager.loadImages($nonSectionedProductLists);
    }

    $(window).on('debouncedresize', function () {
      setTimeout(function () {
        theme.ProductBlockManager.afterImagesResized(); // empty param req
      }, 100); // after third party stuff
    });

    /// Style text-only links
    theme.classUpTextLinks(document); // forms don't all have correct label attributes

    $('#template label').each(function () {
      var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');

      if ($sibinputs.length == 1 && $sibinputs.attr('id').length > 0) {
        $(this).attr('for', $sibinputs.attr('id'));
      }
    }); /// Custom share buttons

    $(document).on('click', '.sharing a', function (e) {
      var $parent = $(this).parent();

      if ($parent.hasClass('twitter')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width = 575;
        var height = 450;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var opts =
          'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
          ',width=' +
          width +
          ',height=' +
          height +
          ',top=' +
          top +
          ',left=' +
          left;
        window.open(url, 'Twitter', opts);
      } else if ($parent.hasClass('facebook')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width = 626;
        var height = 256;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var opts =
          'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
          ',width=' +
          width +
          ',height=' +
          height +
          ',top=' +
          top +
          ',left=' +
          left;
        window.open(url, 'Facebook', opts);
      } else if ($parent.hasClass('pinterest')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width = 700;
        var height = 550;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var opts =
          'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
          ',width=' +
          width +
          ',height=' +
          height +
          ',top=' +
          top +
          ',left=' +
          left;
        window.open(url, 'Pinterest', opts);
      } else if ($parent.hasClass('google')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width = 550;
        var height = 450;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var opts =
          'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
          ',width=' +
          width +
          ',height=' +
          height +
          ',top=' +
          top +
          ',left=' +
          left;
        window.open(url, 'Google+', opts);
      }
    });

    /// Responsive tables
    $('.responsive-table').on(
      'click',
      '.responsive-table__cell-head',
      function () {
        if ($(window).width() < 768) {
          const expandedElement = document.querySelector('tr.expanded');

          if (expandedElement) {
            expandedElement.classList.remove('expanded');
          }

          if (this.closest('tr') !== expandedElement) {
            this.closest('tr').classList.add('expanded');
          }
        }
      }
    ); /// Register all sections

    theme.Sections.init();
    theme.Sections.register('slideshow', theme.SlideshowSection);
    theme.Sections.register('gallery', theme.GallerySection);
    theme.Sections.register(
      'image-with-text-overlay',
      theme.ImageWithTextOverlaySection
    );
    theme.Sections.register(
      'featured-collection',
      theme.FeaturedCollectionSection
    );
    theme.Sections.register(
      'featured-collections',
      theme.FeaturedCollectionsSection
    );
    theme.Sections.register('custom-row', theme.CustomRowSection);
    theme.Sections.register('featured-product', theme.FeaturedProductSection);
    theme.Sections.register('header', theme.HeaderSection, {
      deferredLoad: false,
    });
    theme.Sections.register('announcement-bar', theme.AnnouncementBarSection, {
      deferredLoad: false,
    });
    theme.Sections.register('footer', theme.FooterSection);

    theme.Sections.register(
      'collection-template',
      theme.CollectionTemplateSection,
      {
        deferredLoad: false,
      }
    );
    theme.Sections.register('blog-template', theme.BlogTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register(
      'list-collections-template',
      theme.ListCollectionsTemplateSection,
      {
        deferredLoad: false,
      }
    );
    theme.Sections.register(
      'page-list-collections-template',
      theme.ListCollectionsTemplateSection,
      {
        deferredLoad: false,
      }
    );
  }); // Register dynamically pulled in sections

  $(function ($) {
    if (cc.sections.length) {
      cc.sections.forEach(function (section) {
        try {
          theme.Sections.register(section.name, section.section);
        } catch (err) {
          console.error(
            'Unable to register section '.concat(section.name, '.'),
            err
          );
        }
      });
    } else {
      console.warn('Barry: No common sections have been registered.');
    }
  });

  // Get array of selected options from optionUpdate event detail
  // and run faux validation to add/remove a message
  document.addEventListener('optionUpdate', (event) => {
    setOptionValidationMessage(event.detail);
  });

  // Add (or remove) a message for options that still may need to be selected
  function setOptionValidationMessage(options) {
    const msgTarget = document.querySelector('.option-validation-message');
    let msg = '';

    // Create array of missing option names based on if they start with "Select a"
    const items = options.reduce((acc, option, index) => {
      if (/^Select a/.test(option)) {
        option = option.split('Select a ')[1].toLowerCase();
        acc.push(option);
      }

      return acc;
    }, []);

    // If we have missing options, build a message
    if (items.length) {
      msg = `*Please select ${items.length === 1 ? 'a' : ''} ${items.join(
        ' and '
      )} ${items.length === 1 ? 'option' : 'options'} before adding to cart.`;
    }

    // Add to appropriate area in the DOM
    if (msgTarget) {
      msgTarget.textContent = msg;
    }
  }
 $(document).ready(function(){
  $('.recently-viewed').slick({
  infinite: false,
  slidesToShow: 4, // Shows a three slides at a time
  slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
  arrows: true, // Adds arrows to sides of slider
  dots: false,// Adds the dots on the bottom
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    }
  ] 
});
});
$(document).on('click', '.quickbuy a', function () {
  $(this).parents(".js-product-listing").find(".quickbuy-container").addClass("quickbuy-active");
  $("body").addClass("quickbuy-open");
});
$(document).on('click', '.quickbuy-container .close-detail', function () {
  $(this).parents(".js-product-listing").find(".quickbuy-container").removeClass("quickbuy-active");
  $("body").removeClass("quickbuy-open");
}); 
})(theme.jQuery);
/* Built with Barry v1.0.7 */
 

// Check if there are reviews on product, if not, 
// hide the review stars element

// function checkAndHide() {
//   const reviewContainers = document.querySelectorAll('.stamped-product-reviews-badge');
//   reviewContainers.forEach((container) => {
//     const rating = container.querySelector('.stamped-badge').getAttribute('data-rating');
//     if (rating === '0.0' || rating === '0') {
//       // console.log(container);
//       container.style.visibility = 'hidden';
//     }
//   });

//   setTimeout(function() {
//     clearInterval(intervalId);
//   }, 500);
// }

// var intervalId = setInterval(checkAndHide, 300);

